import { NewsAlertPayload, NewsAlertViewModel, PaginatedApiResponseModel, PaginationFilterModel } from 'sdk'
import { apiUrls } from 'sdk/api-urls'
import { BaseApi } from '../base.api'

export class NewsAlertApi extends BaseApi {
  public getNewsAlerts(filter: PaginationFilterModel) {
    return this.GET_Request<PaginatedApiResponseModel<NewsAlertViewModel>>(apiUrls.newsAlerts.getNewsAlerts(filter))
  }
  public addNewsAlerts(newsAlert: NewsAlertPayload) {
    const formData = new FormData()
    formData.append('StartDate', newsAlert.StartDate)
    formData.append('ArticleDate', newsAlert.ArticleDate)
    formData.append('Title', newsAlert.Title)
    formData.append('ArticleUrl', newsAlert.ArticleUrl)
    formData.append('ViewAllUrl', newsAlert.ViewAllUrl)
    formData.append('CreatedBy', newsAlert.CreatedBy)
    formData.append('Description', newsAlert.Description)
    formData.append('Image', newsAlert.Image)
    return this.POST_FormDataRequestAsync<NewsAlertViewModel>(apiUrls.newsAlerts.addNewsAlert(), formData)
  }
  public updateNewsAlert(newsAlert: NewsAlertPayload, id: string) {
    const formData = new FormData()
    formData.append('StartDate', newsAlert.StartDate)
    formData.append('ArticleDate', newsAlert.ArticleDate)
    formData.append('Title', newsAlert.Title)
    formData.append('ArticleUrl', newsAlert.ArticleUrl)
    formData.append('ViewAllUrl', newsAlert.ViewAllUrl)
    formData.append('CreatedBy', newsAlert.CreatedBy)
    formData.append('Description', newsAlert.Description)
    formData.append('Image', newsAlert.Image)
    return this.PUT_FormDataRequestAsync<NewsAlertViewModel>(apiUrls.newsAlerts.updateNewsAlert(id), formData)
  }
  public deleteNewsAlert(id: string) {
    return this.DELETE_Request<boolean>(apiUrls.newsAlerts.deleteNewsAlert(id))
  }
  public getLatestNewsAlert() {
    return this.GET_Request<NewsAlertViewModel>(apiUrls.newsAlerts.getLatestNewsAlert())
  }
}
